import { render, staticRenderFns } from "./pane-accounts.vue?vue&type=template&id=1df2f955&scoped=true"
import script from "./pane-accounts.vue?vue&type=script&lang=js"
export * from "./pane-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2f955",
  null
  
)

export default component.exports